export default __webpack_public_path__ + "static/media/freeRead.ebff1a28.png";